import { v4 as uuid4 } from 'uuid'
import mockAnalyzeImage1Src from '@/assets/images/kol/mock-post-1.jpg'
import mockAnalyzeImage2Src from '@/assets/images/kol/mock-post-2.jpg'
import mockAnalyzeImage3Src from '@/assets/images/kol/mock-post-3.jpg'
import { SponsoredPost } from '@/components/kol/detail/collaboration-and-value/sponsored-collaboration'

const mockSponsoredPosts: SponsoredPost[] = [
  {
    id: uuid4(),
    title:
      '在新的一天開始前，我必須跟你們分享我的秘密武器：雷達手沖咖啡組！這個組合絕對是我每天清晨的救星！🌟',
    imageUrls: [mockAnalyzeImage1Src],
    publishedAt: '2022-10-08T15:10:30Z',
    interactiveRate: 0.02832334789,
    viewRate: 2.02374327,
  },
  {
    id: uuid4(),
    title:
      '咖啡愛好者們，讓我們一起來探索雷達手沖咖啡的魅力吧！這是一種獨特而迷人的咖啡沖煮方式，讓我們一起揭開它的神秘面紗。',
    imageUrls: [mockAnalyzeImage2Src],
    publishedAt: '2022-10-08T15:10:30Z',
    interactiveRate: 0.02832334789,
    viewRate: 2.02374327,
  },
  {
    id: uuid4(),
    title:
      '上一篇跟大家分享的雷達手沖咖啡，經過我的爭取，廠商決定提供更新的優惠給大家！',
    imageUrls: [mockAnalyzeImage3Src],
    publishedAt: '2022-10-08T15:10:30Z',
    interactiveRate: 0.02832334789,
    viewRate: 2.02374327,
  },
]

export default mockSponsoredPosts
